<app-loading></app-loading>
  <router-outlet></router-outlet>



<!-- <ngx-spinner></ngx-spinner>
<ngx-spinner size="default" name="s1" type="ball-atom"></ngx-spinner>
<ngx-spinner size="default" name="s2" type="ball-scale-multiple"></ngx-spinner>
<ngx-spinner size="default" name="s3" type="ball-spin-clockwise-fade-rotating"></ngx-spinner> -->
